import {
  USER_MANAGEMENT_SUCCESS,
  USER_MANAGEMENT_FAILED,
  RESET_USER_MANAGEMENT,
  LOADING_USER_MANAGEMENT,
  NETWORK_ERROR_USER_MANAGEMENT,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_USER_MANAGEMENT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case USER_MANAGEMENT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case USER_MANAGEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_USER_MANAGEMENT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_USER_MANAGEMENT:
      return (state = initialState);
    default:
      return state;
  }
};
